module.exports = __webpack_public_path__ + "img/innovahtec.381e7ed9.png";